function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState, useEffect, useRef } from 'react';
import { Space, Button, Modal, message, Skeleton, Card, Divider, Drawer, Table, notification } from "antd";
import { Container, Row, Col } from 'react-bootstrap';
import AddBed from './forms/AddBed';
import Common from './includes/Common';
import { TrashFill, PencilSquare, EyeFill, CashStack, BoxArrowRight } from 'react-bootstrap-icons';
import Care from './Care';
import Invoice from './Invoice';
import HospitalizationOut from './forms/HospitalizationOut';
import ReactToPrint, { PrintContextConsumer } from 'react-to-print';
import EditBed from './forms/EditBed';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";

var RoomView = function RoomView(_ref) {
  var room = _ref.room;

  var _Modal$useModal = Modal.useModal(),
      _Modal$useModal2 = _slicedToArray(_Modal$useModal, 2),
      confirm = _Modal$useModal2[0].confirm,
      contextHolder = _Modal$useModal2[1];

  var ref = useRef();

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isNewBedVisible = _useState2[0],
      setIsNewBedVisible = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isPatientVisible = _useState4[0],
      setIsPatientVisible = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      isDataChanged = _useState6[0],
      setIsDataChanged = _useState6[1];

  var _useState7 = useState([]),
      _useState8 = _slicedToArray(_useState7, 2),
      beds = _useState8[0],
      setBeds = _useState8[1];

  var _useState9 = useState(true),
      _useState10 = _slicedToArray(_useState9, 2),
      isDataLoading = _useState10[0],
      setIsDataLoading = _useState10[1];

  var _useState11 = useState([]),
      _useState12 = _slicedToArray(_useState11, 2),
      bedsData = _useState12[0],
      setBedsData = _useState12[1];

  var _useState13 = useState(false),
      _useState14 = _slicedToArray(_useState13, 2),
      showInvoice = _useState14[0],
      setShowInvoice = _useState14[1];

  var _useState15 = useState(null),
      _useState16 = _slicedToArray(_useState15, 2),
      selectedBed = _useState16[0],
      setSelectedBed = _useState16[1];

  var _useState17 = useState(false),
      _useState18 = _slicedToArray(_useState17, 2),
      showOut = _useState18[0],
      setShowOut = _useState18[1];

  var _useState19 = useState(false),
      _useState20 = _slicedToArray(_useState19, 2),
      showEditBed = _useState20[0],
      setShowEditBed = _useState20[1];

  var handleAddBed = function handleAddBed() {
    setIsNewBedVisible(true);
  };

  var cols = [{
    title: "Num. lit",
    dataIndex: "label",
    render: function render(text) {
      return /*#__PURE__*/_jsx("span", {
        children: text
      });
    },
    key: "label"
  }, {
    title: "Status",
    dataIndex: "status",
    render: function render(text) {
      return /*#__PURE__*/_jsx("span", {
        children: text == 0 ? /*#__PURE__*/_jsx("div", {
          style: {
            width: "12px",
            height: "12px",
            borderRadius: "12px",
            background: "#E69671"
          }
        }) : /*#__PURE__*/_jsx("div", {
          style: {
            width: "12px",
            height: "12px",
            borderRadius: "12px",
            background: "#71E687"
          }
        })
      });
    },
    key: "status"
  }, {
    title: "Montant",
    dataIndex: "amount",
    render: function render(text) {
      return /*#__PURE__*/_jsx("span", {
        children: text.toLocaleString("Fr")
      });
    },
    key: "amount"
  }, {
    title: "Caution",
    dataIndex: "deposit",
    render: function render(text) {
      return /*#__PURE__*/_jsx("span", {
        children: text.toLocaleString("Fr")
      });
    },
    key: "deposit"
  }, {
    title: "Reste",
    dataIndex: "av_deposit",
    render: function render(text) {
      return /*#__PURE__*/_jsx("span", {
        children: text.toLocaleString("Fr")
      });
    },
    key: "av_deposit"
  }, {
    title: "Patient",
    dataIndex: "customer",
    render: function render(text) {
      return /*#__PURE__*/_jsx("span", {
        children: text
      });
    },
    key: "customer"
  }, {
    title: "",
    dataIndex: "bed",
    render: function render(b) {
      return /*#__PURE__*/_jsxs(Space, {
        direction: "horizontal",
        children: [/*#__PURE__*/_jsx(Button, {
          type: "link",
          disabled: !b.hospitalization,
          icon: /*#__PURE__*/_jsx(EyeFill, {}),
          onClick: function onClick() {
            setIsPatientVisible(true);
          },
          children: /*#__PURE__*/_jsx("b", {
            children: "VISIT."
          })
        }), /*#__PURE__*/_jsx(Button, {
          type: "default",
          icon: /*#__PURE__*/_jsx(PencilSquare, {
            size: 19
          }),
          onClick: function onClick() {
            setSelectedBed(b);
            setShowEditBed(true);
          },
          children: /*#__PURE__*/_jsx("b", {})
        }), contextHolder, /*#__PURE__*/_jsx(Button, {
          type: "default",
          icon: /*#__PURE__*/_jsx(TrashFill, {
            size: 19
          }),
          onClick: function onClick() {
            handleDelete(b);
          },
          children: /*#__PURE__*/_jsx("b", {})
        }), /*#__PURE__*/_jsx(Button, {
          type: "default",
          disabled: !b.hospitalization,
          icon: /*#__PURE__*/_jsx(CashStack, {
            size: 19
          }),
          onClick: function onClick() {
            setSelectedBed(b);
            setShowInvoice(true);
          },
          children: /*#__PURE__*/_jsx("b", {})
        }), /*#__PURE__*/_jsx(Button, {
          type: "primary",
          disabled: !b.hospitalization,
          style: {
            background: "#1A8754"
          },
          icon: /*#__PURE__*/_jsx(BoxArrowRight, {
            size: 15
          }),
          onClick: function onClick() {
            setSelectedBed(b);
            setShowOut(true);
          },
          children: " Sortie"
        })]
      });
    },
    key: "bed"
  }];

  var handleDelete = function handleDelete(b) {
    confirm({
      title: /*#__PURE__*/_jsx("b", {
        children: "Confirmez-vous ?"
      }),
      content: /*#__PURE__*/_jsxs("p", {
        children: ["La suppression du lit ", b.label]
      }),
      onOk: function onOk() {
        axios.get(Common.baseApiUrl + "deletebed/" + b.id + "/" + Common.currentUser.id).then(function (response) {
          if (response.data.status == 200) {
            notification.success({
              message: "Ok!",
              description: response.data.message
            });
            setIsDataChanged(true);
          } else {
            notification.error({
              message: "Erreur!",
              description: response.data.message
            });
          }
        })["catch"](function (error) {
          notification.error({
            message: "Erreur!",
            description: "Une erreur est survenue " + error.toString()
          });
        })["finally"](function () {});
      }
    });
  };

  useEffect(function () {
    setIsDataChanged(false);
    setIsDataLoading(true);
    axios.get(Common.baseApiUrl + 'getbeds/' + room.id.toString() + '/' + Common.currentUser.id.toString()).then(function (response) {
      if (response.data.status == 200) {
        setBedsData([]);
        setBeds(response.data.beds);
        response.data.beds.forEach(function (b) {
          var am = 0;
          b.hospitalization && b.hospitalization.bills.forEach(function (bi) {
            am += bi.total_amount;
          });
          setBedsData(function (prev) {
            return [].concat(_toConsumableArray(prev), [{
              label: b.label,
              status: b.hospitalization ? 1 : 0,
              deposit: b.hospitalization ? b.hospitalization.deposit : "",
              av_deposit: b.hospitalization ? b.hospitalization.deposit - am : "",
              bed: b,
              amount: am,
              customer: b.hospitalization && b.hospitalization.customer && b.hospitalization.customer.firstname + " " + b.hospitalization.customer.lastname
            }]);
          });
        });
      }
    })["catch"](function (error) {
      message.error({
        content: 'Une erreur est survenue ' + error.toString(),
        delay: 4
      });
    })["finally"](function () {
      setIsDataLoading(false);
    });
  }, [isDataChanged]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Space, {
      direction: "horizontal",
      children: /*#__PURE__*/_jsx(AddBed, {
        room: room,
        handler: function handler() {
          message.success({
            content: 'Opération réussie',
            delay: 4
          });
          setIsDataChanged(true);
        }
      })
    }), /*#__PURE__*/_jsx(Divider, {}), /*#__PURE__*/_jsx(Container, {
      style: {
        minHeight: '400px'
      },
      children: /*#__PURE__*/_jsxs(Row, {
        children: [/*#__PURE__*/_jsx(Col, {
          lg: 9,
          md: 9,
          children: /*#__PURE__*/_jsx(Row, {
            children: /*#__PURE__*/_jsx(Table, {
              loading: isDataLoading,
              columns: cols,
              dataSource: bedsData
            })
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 3,
          md: 3
        })]
      })
    }), /*#__PURE__*/_jsx(Modal, {
      title: /*#__PURE__*/_jsx("b", {
        style: {
          color: '#EEE'
        },
        children: " "
      }),
      destroyOnClose: true,
      footer: null,
      headerStyle: {
        background: '#2D3E4E',
        borderRadius: '0px',
        color: '#EEE'
      },
      open: isNewBedVisible,
      onCancel: function onCancel() {
        setIsNewBedVisible(false);
      }
    }), /*#__PURE__*/_jsx(Drawer, {
      title: /*#__PURE__*/_jsx("b", {
        style: {
          color: '#EEE'
        },
        children: " "
      }),
      destroyOnClose: true,
      width: "90%",
      headerStyle: {
        background: '#2D3E4E',
        borderRadius: '0px',
        color: '#EEE'
      },
      open: isPatientVisible,
      onClose: function onClose() {
        setIsPatientVisible(false);
      },
      children: /*#__PURE__*/_jsx(Care, {})
    }), selectedBed && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Drawer, {
        title: /*#__PURE__*/_jsxs("b", {
          style: {
            color: '#EEE'
          },
          children: ["Facture - ", selectedBed.label]
        }),
        destroyOnClose: true,
        width: "80%",
        headerStyle: {
          background: '#2D3E4E',
          borderRadius: '0px',
          color: '#EEE'
        },
        open: showInvoice,
        onClose: function onClose() {
          setShowInvoice(false);
        },
        extra: [/*#__PURE__*/_jsx(ReactToPrint, {
          content: function content() {
            return ref.current;
          },
          children: /*#__PURE__*/_jsx(PrintContextConsumer, {
            children: function children(_ref2) {
              var handlePrint = _ref2.handlePrint;
              return /*#__PURE__*/_jsx(Button, {
                type: "primary",
                onClick: handlePrint,
                children: /*#__PURE__*/_jsx("b", {
                  children: "Imprimer"
                })
              });
            }
          })
        })],
        children: /*#__PURE__*/_jsx("div", {
          ref: ref,
          children: /*#__PURE__*/_jsx(Invoice, {
            ref: ref,
            hospitalization: selectedBed.hospitalization
          })
        })
      }), /*#__PURE__*/_jsx(Modal, {
        title: /*#__PURE__*/_jsxs("b", {
          children: ["Sortie - ", selectedBed.label]
        }),
        destroyOnClose: true,
        width: {
          xs: '95%',
          sm: '80%',
          md: '60%',
          lg: '50%',
          xl: '50%',
          xxl: '50%'
        },
        headerStyle: {
          background: '#2D3E4E',
          borderRadius: '0px',
          color: '#EEE'
        },
        footer: null,
        open: showOut,
        onCancel: function onCancel() {
          setShowOut(false);
        },
        children: /*#__PURE__*/_jsx(HospitalizationOut, {
          hospitalization: selectedBed.hospitalization,
          handler: function handler() {
            setIsDataChanged(true);
            setShowOut(false);
          }
        })
      }), /*#__PURE__*/_jsx(Modal, {
        title: /*#__PURE__*/_jsxs("b", {
          children: ["Modifier les infos du lit - ", selectedBed.label]
        }),
        destroyOnClose: true,
        width: {
          xs: '90%',
          sm: '80%',
          md: '70%',
          lg: '60%',
          xl: '50%',
          xxl: '40%'
        },
        footer: null,
        open: showEditBed,
        onCancel: function onCancel() {
          setShowEditBed(false);
        },
        children: /*#__PURE__*/_jsx(EditBed, {
          bed: selectedBed,
          handler: function handler() {
            setIsDataChanged(true);
          }
        })
      })]
    })]
  });
};

export default RoomView;